import { render } from "./ClassNameList.vue?vue&type=template&id=8898aef0&scoped=true"
import script from "./ClassNameList.vue?vue&type=script&lang=js"
export * from "./ClassNameList.vue?vue&type=script&lang=js"

import "./ClassNameList.vue?vue&type=style&index=0&id=8898aef0&scoped=true&lang=css"

import exportComponent from "/Users/shenshenmac/codes/fan_mei/fanmei_v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8898aef0"]])

export default __exports__